import React, { useEffect, useState } from "react";

import { format } from "date-fns";

import ic_checkmark from "../utils/ic_checkmark_button.png"
import ic_no_data from "../utils/ic_no_data_to_show.svg"
import ic_timeline_circle_indicator from "../utils/ic_timeline_icon.svg"

function QuotationCommentContainer({
    callAPIToChangeStatus,
    productsInQuotationState,
    nextActionSelectedByUser,
    fullHistoryOfStatusChange,
    handleComment,
    commentState,
    setNextActionSelectedByUser
}) {


    const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);

    useEffect(() => {
        const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
        const userAccessGroup = currentUserObject[0].accessgrp;
        setCurrentUserGroupAccess(userAccessGroup);
    }, [])


    return (
        <div>

            <div className="bg-gray-100 rounded border" style={{ height: "140px", overflowY: "scroll", padding: "4px", marginRight: "10px" }}>
                {
                    fullHistoryOfStatusChange ?
                        fullHistoryOfStatusChange.length > 0 ?
                            fullHistoryOfStatusChange?.map((item) => {
                                return (
                                    <div className=" bg-white border rounded shadow p-2">
                                        <p className="flex">
                                            <div>
                                                <img src={ic_timeline_circle_indicator } />
                                            </div>
                                            <div className="ms-2">
                                                <div className="flex">
                                                    <div>
                                                        <span className="text-xs">{format(item.create_date, "dd-MM-yyyy")} </span>
                                                        <span className="text-xs" style={{ marginLeft: "5px" }}>{format(item.create_date, "hh-mm a")} </span>
                                                    </div>
                                                    <div className="px-1">
                                                        <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-gray-700 dark:text-gray-300"> {item.status} </span>
                                                    </div>
                                                </div>
                                                <div>

                                                    <span>{item.Comments}</span>
                                                </div>
                                            </div>

                                        </p>


                                    </div>
                                )
                            })
                            :
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img style={{ width: "90px" }} src={ic_no_data} />
                                <p className="p-2 text-slate-500" > No data in proposal timeline</p>
                            </div>
                        :
                        <p>Unable to fetch proposal timeline, please try later</p>
                }
            </div>

            <div style={{ display: "flex" }}>
                { (currentUserAccessGroup?.trim().toUpperCase() == "ADMIN" || currentUserAccessGroup?.trim().toUpperCase() == "CADMIN") &&
                    productsInQuotationState &&
                    productsInQuotationState[0]?.area_code == "For Approval" && (
                        <>
                            <button
                                style={{ display: "flex" }}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                onClick={() =>
                                    setNextActionSelectedByUser("Approved")
                                }
                            >
                                {nextActionSelectedByUser == "Approved" && <img style={{ width: "20px" }} src={ic_checkmark} />}
                                Approve
                            </button>
                            <button
                                style={{ display: "flex" }}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                onClick={() =>

                                    setNextActionSelectedByUser("Reject")
                                }
                            >
                                {nextActionSelectedByUser == "Reject" && <img style={{ width: "20px" }} src={ic_checkmark} />}
                                Reject
                            </button>
                            <button
                                style={{ display: "flex" }}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                onClick={() =>
                                    setNextActionSelectedByUser("Re-Evaluate")
                                }
                            >
                                {nextActionSelectedByUser == "Re-Evaluate" && <img style={{ width: "20px" }} src={ic_checkmark} />}
                                Re Evaluate
                            </button>
                        </>
                    )}

            </div>

            <div style={{ display: "flex", alignItems: "flex-end" }}>
                <div style={{ flexGrow: 1, marginRight: "10px" }}>
                    <textarea value={commentState} onChange={(e) => handleComment(e)} placeholder="Enter comments" className="p-2 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 " style={{ width: "100%", height:"45px" }} />
                </div>

                <div>

                    {productsInQuotationState && nextActionSelectedByUser &&
                        (productsInQuotationState[0]?.area_code != nextActionSelectedByUser) &&
                        <button
                            onClick={() => callAPIToChangeStatus(commentState)} // eralier we changed status in ui then we had to press Save button sendForApprovalClicked(), now calling api from here
                            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
                        >
                            Send
                        </button>
                    }
                </div>

            </div>


        </div>
    )
}

export default QuotationCommentContainer